import { Col } from "react-bootstrap";
import { PagedSubscript } from "./EPagedSubscript";
import { EFolder } from "./EFolder";

export const documentTypes = {
    script : {
        Editor : function (scriptId,subscriptId){
            return (<PagedSubscript 
                key = "Editor"
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                blockTypes = {[
                    {key:'c',name:'Character',type:'character'},
                    {key:'d',name:'Dialog',type:'dialog'},
                    {key:'s',name:'Scene Heading',type:'scene'},
                    {key:'h',name:'Shot',type:'shot'},
                    {key:'e',name:'Section',type:'section'},
                    {key:'q',name:'Sequence',type:'sequence'},
                    {key:'n',name:'Note',type:'note'},
                    {key:'a',name:'Action',type:'action'},
                    {key:'t',name:'Transition',type:'transition'},
                    {key:'p',name:'Parenthetical',type:'parenthetical'},
                ]}
                blockContinuationRules = {{
                    character: 'dialog',
                    parenthetical : 'dialog',
                    dialog : 'dialog',
                    transition : 'scene',
                    note : 'note',
                    section : 'note',
                    sequence : 'note',
                    default : 'action',
                }}
                blankEnterForBlockType = {true}  
                font = "18px Courier, fixed"
            />)
        },
        levels : {
            section : 1,
            sequence : 2,
            scene : 3
        },
        textToBlocks : function (text) {

            var paras = (text.indexOf("\n")!=-1)?text.split("\n"):text.split("\r");
            var prevBlockType = "action"
            var blocks = [];

            for (var p=0;p<paras.length;p++){
                var para = paras[p];

                para = para.trim();
                para = para.replace(/(\r)/gm, "");
                para = para.replace(/(\n)/gm, "");

                if (para){

                    var blockType ='action';

                    if ( para.toUpperCase()==para ) {  

                        if (para.length>4 && ( para.substring(0,4)=="INT." || para.substring(0,4)=="EXT.")) {
                            blockType = 'scene'
                        } else if ( para.indexOf("CAMERA") >-1 || para.indexOf("ANGLE") >-1 ||  para.indexOf("CLOSE" ) >-1 ) {
                            blockType = 'shot'
                        } else if (para.indexOf("CUT") >-1 || para.indexOf("FADE" )>-1) {
                            blockType = 'transition'                
                        } else {
                            blockType = 'character'
                        }

                    } else {

                        if ( para.substring(0,1) == "(") {
                            blockType= 'parenthetical';
                        } else if ( (prevBlockType == 'character') || (prevBlockType == 'parenthetical') ){
                            blockType= 'dialog';
                        }

                    }

                    prevBlockType = blockType;
                    blocks.push ({
                        type:blockType,
                        text:para
                    });

                }

            }


            return blocks;
        }
    },
    note : {
        Editor : function Note (scriptId,subscriptId){
            return (<PagedSubscript 
                key = "Editor"
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                blockTypes = {[
                    {key:'p',name:'Paragraph',type:'noteParagraph'},                    
                    {key:'o',name:'Option',type:'noteOption'},
                    {key:'h',name:'Heading',type:'noteHeading'},
                    {key:'s',name:'Sub Heading',type:'noteSubheading'},
                    {key:'2',name:'Sub Heading 2',type:'noteSubheading2'},
                    {key:'b',name:'Bold',type:'noteBold'},
                ]}
                blockContinuationRules = {{
                    noteOption : 'noteOption',
                    default : 'noteParagraph'
                }}
                font = "15px Arial, sans-serif"
                blankEnterForBlockType = {false}  
            />);
        },
        levels : {
            noteHeading : 1,
            noteSubheading : 2,
            noteSubheading2 : 3,
        },
        textToBlocks : function (text) {

            var paras = (text.indexOf("\n")!=-1)?text.split("\n"):text.split("\r");
            var prevBlockType = "action"
            var blocks = [];

            for (var p=0;p<paras.length;p++){
                var para = paras[p];

                var indent = para.split("\t").length-1;
                para = para.trim();
                // var indent = 0;

                // for (var i = 0;i<para.length;i++){
                //     if (para.substring(i,i+1)=='\t'){
                //         indent++;
                //     } else {
                //         break;
                //     }
                // }
                para = para.replace(/(\r)/gm, "");
                para = para.replace(/(\n)/gm, "");
                para = para.replace(/(\t)/gm, "");

                if (para){

                    blocks.push ({
                        type:'noteParagraph',
                        text:para,
                        meta: {
                            indent : indent
                        }
                    });

                }

            }

            return blocks;
        }
    },
    directory : {
        Editor : function Directory (scriptId,subscriptId){
            return (<EFolder 
                scriptId = {scriptId}
                subscriptId = {subscriptId}
            />)
        },
        levels : {}
    },
    wall : {
        Editor : function Directory (scriptId,subscriptId){
            return (<EFolder 
                scriptId = {scriptId}
                subscriptId = {subscriptId}
            />)
        },
        levels : {}
    },
}

